<template>
  <div class="mb25 mt15">
    <span class='mr15'>
      <a-button type="primary" v-has:storeCreate="()=> {$router.push('/customer/store/store_add?type=add')}">
        <PlusOutlined />
        添加门店
      </a-button>
    </span>
        <span class='mr15'>
      <a-button type="primary" v-has:storeExport="exportTable">
        导出门店
      </a-button>
    </span>
         <span class='mr15'>
            <a-button type="primary" v-has:batchEditSubBrand="()=> batchEditSubB()">
              批量修改门店品牌
            </a-button>   
          </span>
          <!-- 批量导入门店 -->
          <span class='mr15'>
            <a-button type="primary" v-has:batchImportStore="()=>{fileList = [];importVisible=true;}">
              批量导入门店
            </a-button>   
          </span>
          <!-- 下载导入模板 -->
          <span class='mr15'>
            <a-button type="primary" v-has:batchImportTemp="()=>{importStoreVisible=true}">
              下载导入模板
            </a-button>   
          </span>
  </div>
  <a-form ref='form' :model='search' :style="{'marginBottom':'25px'}" :initialValues="search"
    :onFinish='pageSearchChange' layout='inline'>
    <a-form-item label="关键字" name='keyword'>
      <a-input v-model:value="search.keyword" :style="{width:'300px'}" placeholder="请输入门店编号/名称/手机号码进行搜索" />
    </a-form-item>
    <a-form-item label="状态" name='status' v-if='open'>
      <a-select v-model:value="search.status" :style="{width:'200px'}" placeholder="全部">
        <a-select-option value="">全部</a-select-option>
        <a-select-option value="1">正常</a-select-option>
        <a-select-option value="0">禁用</a-select-option>
        <!-- <a-select-option value="2">待激活</a-select-option> -->
      </a-select>
    </a-form-item>
    <a-form-item label="门店类型" name='' v-if='open'>
      <a-select v-model:value="search.type_id" :style="{width:'200px'}" placeholder="全部">
        <a-select-option value="">全部</a-select-option>
        <a-select-option v-for='item in typeList' :key='item.type_id' :value="item.type_id">{{item.type_name}}
        </a-select-option>
      </a-select>
    </a-form-item>

     <a-form-item label="门店级别" name='' v-if='open'>
      <a-select v-model:value="search.level_id" :style="{width:'200px'}" placeholder="全部">
        <a-select-option value="">全部</a-select-option>
        <a-select-option v-for='item in levelList' :key='item.id' :value="item.id">{{item.level_name}}</a-select-option>
      </a-select>
    </a-form-item>

    <a-form-item label="门店地址" name='' v-if='open'>
      <selectCity class="m-r-20" v-on:citychange='citychange' placeholder="请选择门店地址"></selectCity>
    </a-form-item>
    <a-form-item label="" name='' v-if='open'>
      <a-input v-model:value="search.street" :style="{width:'300px'}" placeholder="请输入详细地址" />
    </a-form-item>
          <a-form-item label="创建日期" name='time'  v-if='open'>
          <a-range-picker  valueFormat='YYYY-MM-DD' format='YYYY-MM-DD' @change="onChange" />
        </a-form-item>
    <a-form-item label="绑定微信账号" name='is_bind_wechat' v-if='open'>
      <a-select v-model:value="search.is_bind_wechat" :style="{width:'140px'}" placeholder="全部">
        <a-select-option value="">全部</a-select-option>
        <a-select-option :value="1">绑定微信</a-select-option>
        <a-select-option :value="2">未绑定微信</a-select-option>
      </a-select>
    </a-form-item>
       <a-form-item ref="" label="所属上级" name="" :label-col="{ span: 5 }" :wrapper-col="{ span: 15 }"  class="m-r-20" v-if='open'>
      <a-row :gutter="10">
        <a-col :span="8" hidden>
          <a-input readonly v-model:value='search.parent_id' placeholder="上级ID"></a-input>
        </a-col>
        <a-col :span="20">
          <a-input readonly v-model:value='search.parent_name' placeholder="上级名称"></a-input>
        </a-col>
        <a-col :span="4">
          <a-button type="primary" @click='showDealer=true'>选择</a-button>
        </a-col>
      </a-row>
    </a-form-item>
    <a-form-item>
      <a-button type="primary" htmlType='submit'>搜索</a-button>
    </a-form-item>
    <!-- <a-form-item>
      <a-button type="primary" ghost>导出</a-button>
    </a-form-item> -->
    <!-- <a-form-item>
      <a-button type="primary" ghost>导入</a-button>
    </a-form-item> -->
    <a-form-item>
      <a href="javascript:;" @click='open = !open'>{{open ? '收起':'展开'}}</a>
      <UpOutlined v-if='open'/>
      <DownOutlined  v-else/>
    </a-form-item>
  </a-form>
  <a-table class='tableFixBox' :pagination='false' :loading='listLoading' bordered rowKey='id' :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }" :columns='columns' :data-source='data'  :scroll="{ x: 'max-content'}">
    <template v-slot:store_name="{ record }">
      <p >{{record.store_name || '-'}}</p>
      ({{record.level_name}})
    </template>
    <template v-slot:clerk_name="{ record }">
      <p >{{record.clerk_name || '-'}}</p>
      ({{record.clerk_phone}})
    </template>
    <template v-slot:is_bind_wechat="{ record }">
      <a-popover placement="right" v-if='record.wechat'>
        <template #content>
          <div class="s_flex_ali">
            <img class="width-100 height-100 m-r-15" :src="record.wechat ? record.wechat.headimgurl :''" alt="">
            <div>
              <p class="s_c333 s_lin_h28">微信昵称：{{record.wechat ? record.wechat.nick_name :'-'}}</p>
              <p class="s_c333 s_lin_h28">客户ID：{{record.wechat ? record.wechat.id :'-'}}</p>
              <p class="s_c333 s_lin_h28">地区：{{record.wechat ? record.wechat.area :'-'}}</p>
              <p class="s_c333 s_lin_h28">会员等级：{{record.wechat ? record.wechat.vip_level :'-'}}</p>
            </div>
          </div>
        </template>
        <a href="javascript:;" class="s_omit width-120 ds-b">{{record.wechat ? record.wechat.nick_name :'-'}}</a>
      </a-popover>
      <p v-else>-</p>
    </template>
    <template v-slot:action="{ record }">
      <a-dropdown>
        <a class="ant-dropdown-link"> 操作
          <DownOutlined />
        </a>
        <template v-slot:overlay>
          <a-menu>
            <a-menu-item>
              <a v-has:storeDetail="()=>{$router.push('/customer/store/store_detail?type=look&id='+record.id)}" href="javascript:;">详情</a>
            </a-menu-item>
             <a-menu-item>
              <a v-has:storeWriteCode="()=>getStoreCode(record)" href="javascript:;">核销码</a>
            </a-menu-item>
            <a-menu-item>
              <a v-has:storeEdit="()=> {$router.push('/customer/store/store_edit?type=edit&id='+record.id)}"
                href="javascript:;">修改</a>
            </a-menu-item>
            <a-menu-item>
              <a v-has:storeStatus="()=>setStoreStatus(record)" href="javascript:;">{{record.status ? '禁用':'启用'}}</a>
            </a-menu-item>
             <a-menu-item v-if="!record.status">
              <a v-has:storeDel="()=>delStore(record)" href="javascript:;">删除</a>
            </a-menu-item>
            <a-menu-item>
              <a v-has:storeEditGrowth="()=>{storeData = record;showEdit = true;growthNum = null}" href="javascript:;">修改成长值</a>
            </a-menu-item>
            <a-menu-item>
              <a href="javascript:;" v-has:sendPoints="()=>{integralType=1;integralValue=null;redValue=JSON.parse(JSON.stringify(record));integralStatus=true;}">送积分</a>
            </a-menu-item>
            <a-menu-item>
              <a href="javascript:;" v-if="record.wechat" v-has:sendRed="()=>{integralType=2;integralValue=null;redValue=JSON.parse(JSON.stringify(record));integralStatus=true;}">派送红包</a>
            </a-menu-item>
          </a-menu>

        </template>
      </a-dropdown>
    </template>
  </a-table>
  <a-pagination :style="{marginTop:'20px',textAlign:'right'}" show-size-changer show-quick-jumper :current="search.page"
  :page-size="search.limit" :total="total" @change="pageCurrentChange" @showSizeChange="pageSizeChange" :show-total="total => `总数: ${total} `" />
  <a-modal  :keyboard="false" :title="storeName" centered :width='600' :footer="null" v-model:visible="visibleWriteCode" destroyOnClose>
    <img :src="writeCode" alt="" style="display:block;margin:0 auto">
    <div style="display:flex;justify-content:center">
        <!-- <a-button type="primary" @click="()=> {$router.push('/customer/store/store_add?type=add')}">
      下载核销码
    </a-button> -->
    </div>
  </a-modal>
  <a-modal  :keyboard="false" :maskClosable='false' title="修改成长值" centered :width='600' v-model:visible="showEdit" destroyOnClose @ok='editGrowth'>
    <a-descriptions :column='1'>
      <a-descriptions-item label="门店名称">{{storeData.store_name}}</a-descriptions-item>
      <a-descriptions-item label="成长值">{{storeData.growth_value}}</a-descriptions-item>
      <a-descriptions-item label="添加值">
        <a-input-number v-model:value="growthNum" style="width:400px" placeholder='请输入成长值' :precision='0' />
      </a-descriptions-item>
      <a-descriptions-item label=""><p class="s_c999">请输入添加的成长值，输入负数扣除成长值，总成长值不能小于0</p></a-descriptions-item>
    </a-descriptions>
  </a-modal>
    <a-modal  :keyboard="false" title="选择经销商" centered v-model:visible="showDealer" :width='1000' :footer="null" destroyOnClose>
    <selectDealer v-on:select="select" :checkout='false' :mustShowHeadquarters='true'></selectDealer>
  </a-modal>
  <a-modal  :keyboard="false" :maskClosable='false' :title="integralType==1?'送积分':'派送红包'" centered :width='600' v-model:visible="integralStatus" destroyOnClose @ok='integralConfirm'>
     <a-form :label-col="{span: 4, offset: 2}" :wrapper-col="{span: 20, offset: 1}">
       <a-form-item label="门店名称">
         <p>{{redValue.store_name || '无'}}</p>
      </a-form-item>
       <a-form-item label="门店负责人">
         <p>{{redValue.clerk_name || '无'}}</p>
      </a-form-item>
      <a-form-item label="积分数" v-if="integralType==1" required>
         <a-input-number v-model:value="integralValue" style="width:80%" placeholder="请输入积分数"></a-input-number>
         <p class="s_c999" style="line-height:25px">可输入负数（负数为扣除积分）</p>
      </a-form-item>
       <a-form-item label="微信红包" v-else required>
         <a-input v-model:value="redValue.amount" style="width:60%" placeholder="选择微信红包" readonly></a-input><a-button type="primary" class="m-l-10" @click="redStatus=true">选择</a-button>
         <p class="s_c999" style="line-height:25px;font-size:12px">微信红包需要在门店绑定微信且关注品牌公众号的情况下才能成功发送，如果门店未绑定微信或未关注公众号，红包将无法发放到门店负责人微信。</p>
      </a-form-item>
     </a-form>
  </a-modal>

  <!--  -->
   <a-modal  :keyboard="false" :maskClosable='false' title="选择红包" :footer="null" centered :width='1200' v-model:visible="redStatus" destroyOnClose>
     <redList :id="redValue.id" @change="control"></redList>
   </a-modal>
       <a-modal :keyboard="false" title="选择品牌" centered v-model:visible="brandVisible" @ok="handleBrandChoose" destroyOnClose>
        <a-form-item label="品牌"><selectBrand v-model:value="brand_id" /></a-form-item>
  </a-modal>
  <!-- 批量导入门店 -->
  <a-modal :keyboard="false" centered title="批量导入门店（数据中出现异常，整个文件的数据将无法导入）" v-model:visible="importVisible" :width='800' :footer="null" destroyOnClose>
    <a-card :bordered="false">
      <a-upload-dragger v-model:fileList="fileList" name="files" :multiple="false" :action="action" :headers="{Authorization:getToken()}" @change="handleChange">
        <p class="ant-upload-drag-icon">
          <inbox-outlined></inbox-outlined>
        </p>
        <p class="ant-upload-text">点击上传或者拖拽上传</p>
      </a-upload-dragger>
      <!-- <p style="color:#f04635">{{uploadStatus}}</p> -->
    </a-card>
  </a-modal>
  <!-- 下载模板 -->
   <a-modal :keyboard="false" centered title="导入模板规则" v-model:visible="importStoreVisible" :width='700' :footer="null" destroyOnClose>
       <div>
         <p>1.通过模板批量导入的门店无法在云店中使用，需要手动设置门店所在位置和定位后才能正常使用;</p>
         <p class="m-t-10">2.门店类型请输入“门店管理-门店设置-门店类型”中的类型编号;</p>
         <p class="m-t-10">3.门店属于总部直营店，门店的经销商编号请输入0;</p>
         <p class="m-t-10">4.省、市、区、详细地址输入错误，创建门店时不生效;</p>
         <p class="m-t-10">5.一次导入门店不能多于500个;</p>
         <a-button class="m-t-20" style="transform: translateX(-50%);margin-left:50%;" type="primary" @click="exportTemplate">下载模板</a-button>
       </div>
   </a-modal>
</template>
<script>
  import { DownOutlined, PlusOutlined ,UpOutlined,InboxOutlined} from "@ant-design/icons-vue";
  import { ref, onMounted, inject, reactive, toRefs } from "vue";
  import { message } from "ant-design-vue";
  import { getStoreList, storeStatus, storeDel,getBaseEncode,storeListExport,setGrowthValue,toPoint,toRedEnvelope,storeImport,storeExcel } from "@/api/store";
  import {batchEditSubBrand} from "@/api/dealer";
  import { iscode } from "@/utils/app";
  import redList from './red_list.vue'
  import { getToken } from "@/libs/util";
  import config from "@/config";
  // 初始化默认筛选项数值
  let defSearch = {
    keyword: "",
    level_id: '',
    type_id: '',
    status: '',
    page: 1,
    limit: 8,
    province_id: '',
    city_id: '',
    area_id: '',
    street: '',
    is_bind_wechat:'',
    start_time:"",
    end_time:"",
    parent_name:"",
    parent_id:""
  };
  export default {
    name: "storeList",
    components: { DownOutlined, PlusOutlined ,UpOutlined,redList,InboxOutlined},
    props: {
      typeList: {
        type: Array
      },
      levelList: {
        type: Array
      }
    },
    setup(props, ctx) {
      // // 初始化 分页信息和筛选项信息
      let search = ref({ ...defSearch });
      // 列表数据和列头配置
      let data = ref([]);
      const state = reactive({
        showDealer:false,
        storeName:'',
        visibleWriteCode:false,//核销码 弹窗
        writeCode:'',//核销码base64
        open:false,
        listLoading: false,
        total: 1,
        selectedRowKeys: [],
        storeData:{},
        showEdit:false,
        growthNum:null,
        integralStatus:false,
        integralValue:null,
        integralType:1, //1积分 2红包
        redStatus:false,
        redValue:{id:null,amount:''},
        importVisible:false,
        action:storeImport(), //接口
        uploadStatus:'',
        fileList:[],
        hideTime:null,
        importStoreVisible:false
      });
      let columns = [
        {
          title: "门店编号",
          dataIndex: "store_code",
          key: "store_code",
        },
        {
          title: "门店名称/级别",
          dataIndex: "store_name",
          key: "store_name",
          slots: { customRender: "store_name" }
        },
        {
          title: "推广门店",
          dataIndex: "extension_store_name",
          key: "extension_store_name",
        },
        {
          title: "门店地址",
          dataIndex: "address",
          key: "address"
        },
        {
          title: "负责人/手机号",
          dataIndex: "clerk_name",
          key: "clerk_name",
          slots: { customRender: "clerk_name" }
        },
        {
          title: "绑定微信账号",
          dataIndex: "wechat",
          key: "wechat",
          slots: { customRender: "is_bind_wechat" }
        },
        {
          title: "所属上级",
          dataIndex: "distributor_name",
          key: "distributor_name",
        },
        {
          title: "门店类型",
           dataIndex: "type_name",
          key: "type_name",
        },
        {
          title: "状态",
          dataIndex: "status_text",
          key: "status_text",
          width:100
        },
           {
          title: "创建日期",
          dataIndex: "create_time",
          key: "create_time",
        },
        {
          title: "最后登录时间",
          dataIndex: "login_time",
          key: "login_time",
        },
        {
          title: "操作",
          key: "action",
          fixed: "right",
          slots: { customRender: "action" },
        },
      ];
      const $Modal = inject('$Modal')
      // 页面筛选项搜索
      const pageSearchChange = () => {
        search.value = { ...search.value, page: 1 };
        initData(search.value);
      };
      // 分页当前页切换
      const pageCurrentChange = (page, pageSize) => {
        search.value.page = page;
        initData(search.value);
      };
      // 分页当前页显示多少条切换
      const pageSizeChange = (current, limit) => {
        search.value.page = 1;
        search.value.limit = limit;
        initData(search.value);
      };
      //修改状态代理商
      const setStoreStatus = (e) => {
        $Modal.confirm({
          centered:true,
          title: '您确定要' + (e.status==1 ? '禁用' : '启用') + '该门店吗？',
          content: (e.status==1 ? '禁用后,门店关联的用户将取消绑定,后续启用也无法自动恢复绑定' : '启用'), onOk: async () => {
            let res = await storeStatus({ id: e.id, status: e.status==1 ? 0 : 1 }).then(res => res.data);
            if (iscode(res)) {
              message.success(res.msg);
              initData(search.value);
            } else {
              message.error(res.msg);
            }
          }
        })
      }
      // 删除门店
      const delStore = (e) => {
        $Modal.confirm({
          centered:true,
          title: '删除门店',
          content: '删除后该门店将无法恢复，您确定要删除该门店吗？', onOk: async () => {
            let res = await storeDel({ id: e.id }).then(res => res.data);
            if (iscode(res)) {
              message.success(res.msg);
              initData(search.value);
            } else {
              message.error(res.msg);
            }
          }
        })
      }
      //修改成长值
      const editGrowth = () =>{
        if(!isNumber(state.growthNum) || state.growthNum == 0){
          message.error('请输入成长值！');
          return
        }
        if(state.growthNum+state.storeData.growth_value < 0){
          message.error('总成长值不能小于0！');
          return
        }
        $Modal.confirm({
          centered:true,
          title: '提示',
          content: '您确定要修改该门店的成长值吗？', onOk: async () => {
            let res = await setGrowthValue({ id: state.storeData.id,growth_value:state.growthNum }).then(res => res.data);
            if (iscode(res)) {
              message.success(res.msg);
              initData(search.value);
              state.showEdit = false
            } else {
              message.error(res.msg);
            }
          }
        })
      }
      //数字判断
      const  isNumber = (obj) => {
        return !isNaN(parseFloat(obj)) && isFinite(obj);
      }
      // 选择省市区
      const citychange = (e) => {
        search.value.province_id = e[0]
        search.value.city_id = e[1]
        search.value.area_id = e[2]
      }
      const initData = async (values) => {
        state.listLoading = true;
        try {
          data.value = [];
          let res = await getStoreList(values).then(res => res.data);
          state.listLoading = false;
          if (iscode(res)) {
            data.value = res.data.data;
            state.total = res.data.total;
          } else {
            message.error(res.msg);
          }
        } catch (e) {
          state.listLoading = false;
        }
      };
          // 时间筛选
      const onChange = (e) => {
        search.value.start_time = e[0]
        search.value.end_time = e[1]
        initData(search.value);
      }
        //批量选中
    const onSelectChange = (selectedRowKeys) => {
      state.selectedRowKeys = selectedRowKeys;
    };
      const getStoreCode=async (data)=>{
          const hide = message.loading('正在加载中...', 0);
          let result=await getBaseEncode({store_id:data.id}).then(res=>res.data).catch(error=>error)
          setTimeout(hide);
         if(iscode(result,true)){
            state.visibleWriteCode=true
            state.writeCode=result.data.baseencode
            state.storeName = '（'+data.store_code+'）'+data.store_name
         }
      }
      //选择经销商
    const select = (e) => {
      if (e == 0) {
        search.value.parent_id = e;
        search.value.parent_name = "总部";
      } else {
        search.value.parent_id = e.dealer_id;
        search.value.parent_name = e.dealer_name;
      }
      state.showDealer = false;
    };
      onMounted(() => {
        initData(search.value);
      });
            const exportTable=async()=>{
           let result=await storeListExport({...search.value,limit:10000}).then(res=>res.data).catch(error=>error)
           if(iscode(result,true)){
             window.open(result.data.file_url)
           }
      }

      const methods ={
        async integralConfirm(){
            if(state.integralType==1&&!state.integralValue) return message.error('请输入积分数！');
            if(state.integralType==2&&!state.redValue['id']) return message.error('请选择微信红包！');
            const hide = message.loading('正在加载中...', 0);
            let result;
            if(state.integralType==1){ //积分
             result = await toPoint({id:state.redValue.id,point:state.integralValue}).then(res=>res.data)
            }else{ //红包
              result = await toRedEnvelope({store_id:state.redValue.store_id,bonus_id:state.redValue.id}).then(res=>res.data)
            }
            setTimeout(hide);
            iscode(result,true)
            state.integralStatus = false;
         },
         control(values){
            state.redValue.store_id = state.redValue.id
            Object.assign(state.redValue,values)
            state.redStatus = false;
         }
      }
            // 修改品牌
        const brandVisible=ref(false)
        const brand_id=ref('')
        const batchEditSubB=()=>{
          console.log( state.selectedRowKeys)
          if(!state.selectedRowKeys.length){
            message.error("请选择门店")
            return
          }
          brandVisible.value=true
        }
        const handleBrandChoose=async()=>{
          let result=await batchEditSubBrand({type:2,ids:state.selectedRowKeys,sub_brand_id:brand_id.value}).then(res=>res.data).catch(error=>error)
          if(iscode(result,true)){
            brandVisible.value=false
          initData(search.value);
          } 
        }
       
        // 控制
      const handleChange=(e)=>{
          state.uploadStatus='';
          state.hideTime = state.hideTime?state.hideTime:message.loading('导入中...');
          
          const status = e.file.status;
           if (status === 'done') {
                if(e.file.response.code==0){
                    // message.success('导入成功')
                    state.importVisible = false;
                     setTimeout(state.hideTime)
                    $Modal.success({
                      title:'导入成功',
                      okText:'确定'
                    })
                    initData(search.value);
                    return false
                }else{
                    state.importVisible = false;
                     setTimeout(state.hideTime)
                    $Modal.error({
                      title:'导入失败',
                      content:e.file.response.msg,
                      okText:'确定'
                    })
                    return false
                }
           }else if (status === 'error'){
                    state.importVisible = false;
                    setTimeout(state.hideTime)
                    $Modal.error({
                      title:'导入失败',
                      // content:'文件太大',
                      okText:'确定'
                    })
               return false
           }
        }

        const exportTemplate = async function(){
              const hide = message.loading("正在加载中...", 0);
              window.open(
                   config.baseUrl[process.env.VUE_APP_type] +"storeExcel"
                 );
               setTimeout(hide);
        }

      return {
        ...toRefs(state),
        search,
        data,
        columns,
        pageSearchChange,
        pageCurrentChange,
        pageSizeChange,
        citychange,
        setStoreStatus,
        delStore,
        getStoreCode,
        exportTable,
        editGrowth,
        onChange,
        select,
        ...methods,
             handleBrandChoose,
        batchEditSubB,
        brand_id,
        brandVisible,
        onSelectChange,
        getToken,
        handleChange,
        exportTemplate
      };
    },
  };
</script>
<style>.ant-table td { white-space: nowrap; }</style>